import PropTypes from 'prop-types';
import React from 'react';

import ResImg from 'components/resImg';
import ResVideo from 'components/resVideo';

const Hero = ({ blok }) => {
  const hasVideo = blok.mobile_video?.filename !== undefined && blok.video?.filename !== '';
  // console.log(blok.fullscreen, blok.add_gutter)
  return (
    <div
      className={`mb-7 bg-primary lg:mb-8 xl:mb-10 ${
        blok.fullscreen ? 'h-mobile-fs xl:h-desktop-fs' : 'h-auto'
      } ${blok.add_gutter ? 'container mt-[0.5rem] pt-5 lg:pt-8 xl:pt-16' : ''}`}
    >
      {hasVideo ? (
        <ResVideo
          mobileVideo={blok.mobile_video}
          desktopVideo={blok.video}
          mobilePoster={blok.mobile_image}
          desktopPoster={blok.image}
        />
      ) : (
        <ResImg mobile={blok.mobile_image} desktop={blok.image} critical />
      )}
    </div>
  );
};

Hero.propTypes = {
  blok: PropTypes.object.isRequired,
};

export default Hero;
